// +----------------------------------------------------------------------
// | CNXRC [ CNXRC赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2026 https://www.cnxrc.net All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CNXRC并不是自由软件，未经许可不能去掉CNXRC相关版权
// +----------------------------------------------------------------------
// | Author: CNXRC Team <admin@cnxrc.net>
// +----------------------------------------------------------------------

import request from '@/utils/request';
import { isPlatform } from '@/utils/settingMer';
var merchantBase = isPlatform ? '/admin/platform/merchant' : '/admin/business/merchant';
var merchantCategoryBase = "".concat(merchantBase, "/category");
var merchantTypeBase = "".concat(merchantBase, "/type");
var merchantApplyBase = "".concat(merchantBase, "/apply");
var platformBusinessApplyBase = '/admin/platform/business/apply';

/**
 * 店铺分类 列表
 */
export function merchantCategoryListApi(params) {
  return request({
    url: "".concat(merchantCategoryBase, "/list"),
    method: 'get',
    params: params
  });
}

/**
 * 店铺分类 全部列表
 */
export function merchantCategoryAllListApi() {
  return request({
    url: "".concat(merchantCategoryBase, "/all/list"),
    method: 'get'
  });
}

/**
 * 店铺分类 添加
 */
export function merchantCategoryAddApi(data) {
  return request({
    url: "".concat(merchantCategoryBase, "/add"),
    method: 'post',
    data: data
  });
}

/**
 * 店铺分类 编辑
 */
export function merchantCategoryUpdateApi(data) {
  return request({
    url: "".concat(merchantCategoryBase, "/update"),
    method: 'post',
    data: data
  });
}

/**
 * 店铺分类 删除
 */
export function merchantCategoryDeleteApi(id) {
  return request({
    url: "".concat(merchantCategoryBase, "/delete/").concat(id),
    method: 'post'
  });
}

/**
 * 店铺类型 列表
 */
export function merchantTypeListApi(params) {
  return request({
    url: "".concat(merchantTypeBase, "/list"),
    method: 'get',
    params: params
  });
}

/**
 * 店铺类型 全部列表
 */
export function merchantTypeAllListApi() {
  return request({
    url: "".concat(merchantTypeBase, "/all/list"),
    method: 'get'
  });
}

/**
 * 店铺类型 添加
 */
export function merchantTypeAddApi(data) {
  return request({
    url: "".concat(merchantTypeBase, "/add"),
    method: 'post',
    data: data
  });
}

/**
 * 店铺类型 编辑
 */
export function merchantTypeUpdateApi(data) {
  return request({
    url: "".concat(merchantTypeBase, "/update"),
    method: 'post',
    data: data
  });
}

/**
 * 店铺类型 删除
 */
export function merchantTypeDeleteApi(id) {
  return request({
    url: "".concat(merchantTypeBase, "/delete/").concat(id),
    method: 'post'
  });
}

/**
 * 商户 列表
 */
export function merchantListApi(params) {
  return request({
    url: '/admin/platform/merchant/list',
    method: 'get',
    params: params
  });
}

/**
 * 店铺列表
 */
export function businessMerchantListApi(params) {
  return request({
    url: '/admin/business/merchant/list',
    method: 'get',
    params: params
  });
}

/**
 * 商户主体后台店铺分页列表表头数量
 */
export function businessMerHeaderNumApi(params) {
  return request({
    url: '/admin/business/merchant/list/header/num',
    method: 'get',
    params: params
  });
}

/**
 * 商户 添加
 */
export function merchantAddApi(data) {
  return request({
    url: "".concat(merchantBase, "/add"),
    method: 'post',
    data: data
  });
}

/**
 * 商户 编辑
 */
export function merchantUpdateApi(data) {
  return request({
    url: "".concat(merchantBase, "/update"),
    method: 'post',
    data: data
  });
}

/**
 * 平台端修改店铺归属商户主体
 * @param {object} data
 */
export function merchantUpdateBusinessApi(data) {
  return request({
    url: '/admin/platform/merchant/update/business',
    method: 'post',
    data: data
  });
}

/**
 * 商户 关闭
 */
export function merchantCloseApi(id) {
  return request({
    url: "".concat(merchantBase, "/close/").concat(id),
    method: 'post'
  });
}

/**
 * 商户 详情
 */
export function merchantDetailApi(id) {
  return request({
    url: "".concat(merchantBase, "/detail/").concat(id),
    method: 'get'
  });
}

/**
 * 商户 开启
 */
export function merchantOpenApi(id) {
  return request({
    url: "".concat(merchantBase, "/open/").concat(id),
    method: 'post'
  });
}

/**
 * 商户 推荐开关
 */
export function merchantSwitchApi(id) {
  return request({
    url: "".concat(merchantBase, "/recommend/switch/").concat(id),
    method: 'post'
  });
}

/**
 * 商户 修改复制商品数量
 */
export function merchantCopyNumApi(data) {
  return request({
    url: "".concat(merchantBase, "/update/copy/product/num"),
    method: 'post',
    data: data
  });
}

/**
 * 商户 修改店铺手机号
 */
export function merchantupdatePhoneApi(data) {
  return request({
    url: "".concat(merchantBase, "/update/phone"),
    method: 'post',
    data: data
  });
}

/**
 * 商户 权限规则菜单列表
 * @param pram
 */
export function menuMerListApi(params) {
  var data = {
    menuType: params.menuType,
    //菜单类型:M-目录，C-菜单，A-按钮
    name: params.name //菜单名称
  };
  return request({
    url: "/admin/platform/merchant/menu/list",
    method: 'get',
    params: data
  });
}

/**
 * 商户 权限规则新增菜单
 * @param data
 */
export function menuMerAdd(data) {
  var systemMenuRequest = data;
  return request({
    url: "/admin/platform/merchant/menu/add",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 商户 权限规则删除菜单
 * @param data
 */
export function menuMerDelete(id) {
  return request({
    url: "/admin/platform/merchant/menu/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 商户 权限规则菜单详情
 * @param data
 */
export function menuMerInfo(id) {
  return request({
    url: "/admin/platform/merchant/menu/info/".concat(id),
    method: 'get'
  });
}

/**
 * 商户 权限规则菜单修改
 * @param data
 */
export function menuMerUpdate(data) {
  var systemMenuRequest = data;
  return request({
    url: "/admin/platform/merchant/menu/update",
    method: 'post',
    data: systemMenuRequest
  });
}

/**
 * 权限规则修改菜单显示状态
 * @param data
 */
export function menuMerUpdateShowStatus(params) {
  return request({
    url: "/admin/platform/merchant/menu/update/show/".concat(params.id),
    method: 'post'
  });
}

/**
 * 店铺入驻分页列表
 * @param data
 */
export function merApplyListApi(params) {
  return request({
    url: "".concat(merchantApplyBase, "/list"),
    method: 'get',
    params: params
  });
}

/**
 * 店铺入驻分页列表表头数量
 * @param data
 */
export function merApplyHeaderNumApi(params) {
  return request({
    url: "".concat(merchantApplyBase, "/list/header/num"),
    method: 'get',
    params: params
  });
}

/**
 * 店铺入驻审核
 * @param data
 */
export function merApplyAuditApi(data) {
  return request({
    url: "".concat(merchantApplyBase, "/audit"),
    method: 'post',
    data: data
  });
}

/**
 * 店铺入驻备注
 * @param data
 */
export function merApplyRemarkApi(data) {
  return request({
    url: "".concat(merchantApplyBase, "/remark"),
    method: 'post',
    data: data
  });
}

/**
 * 商户主体入驻分页列表
 * @param data
 */
export function businessApplyListApi(params) {
  return request({
    url: "".concat(platformBusinessApplyBase, "/list"),
    method: 'get',
    params: params
  });
}

/**
 * 商户主体入驻分页列表表头数量
 * @param data
 */
export function businessApplyHeaderNumApi(params) {
  return request({
    url: "".concat(platformBusinessApplyBase, "/list/header/num"),
    method: 'get',
    params: params
  });
}

/**
 * 商户主体入驻审核
 * @param data
 */
export function businessApplyAuditApi(data) {
  return request({
    url: "".concat(platformBusinessApplyBase, "/audit"),
    method: 'post',
    data: data
  });
}

/**
 * 商户主体入驻备注
 * @param data
 */
export function businessApplyRemarkApi(data) {
  return request({
    url: "".concat(platformBusinessApplyBase, "/remark"),
    method: 'post',
    data: data
  });
}

/**
 * 商户分页列表表头数量
 * @param data
 */
export function merHeaderNumApi(params) {
  return request({
    url: "/admin/platform/merchant/list/header/num",
    method: 'get',
    params: params
  });
}

/**
 * 重置商户密码
 * @param data
 */
export function merRsetPasswordApi(id) {
  return request({
    url: "".concat(merchantBase, "/reset/password/").concat(id),
    method: 'post'
  });
}

/**
 * 可用分类店铺列表
 * @param data
 */
export function merCategoryListApi() {
  return request({
    url: "".concat(merchantBase, "/use/category/list"),
    method: 'get'
  });
}

// ==================== 平台端-商户主体管理 ====================

/**
 * 商户主体列表
 * @param {object} params
 */
export function platformBusinessListApi(params) {
  return request({
    url: '/admin/platform/business/list',
    method: 'get',
    params: params
  });
}

/**
 * 商户主体详情
 * @param {number} id
 */
export function platformBusinessDetailApi(id) {
  return request({
    url: "/admin/platform/business/detail/".concat(id),
    method: 'get'
  });
}

/**
 * 新增商户主体
 * @param {object} data
 */
export function platformBusinessAddApi(data) {
  return request({
    url: '/admin/platform/business/add',
    method: 'post',
    data: data
  });
}

/**
 * 新增商户主体角色选项
 */
export function platformBusinessRoleAddOptionsApi() {
  return request({
    url: '/admin/platform/business/role/add/options',
    method: 'get'
  });
}

/**
 * 修改商户主体
 * @param {object} data
 */
export function platformBusinessUpdateApi(data) {
  return request({
    url: '/admin/platform/business/update',
    method: 'post',
    data: data
  });
}

/**
 * 删除商户主体
 * @param {number} id
 */
export function platformBusinessDeleteApi(id) {
  return request({
    url: "/admin/platform/business/delete/".concat(id),
    method: 'post'
  });
}

/**
 * 修改商户主体状态
 * @param {number} id
 * @param {object} params
 */
export function platformBusinessUpdateStatusApi(id, params) {
  return request({
    url: "/admin/platform/business/update/status/".concat(id),
    method: 'post',
    params: params
  });
}

/**
 * 重置商户主体超管密码
 * @param {number} id
 */
export function platformBusinessResetPasswordApi(id) {
  return request({
    url: "/admin/platform/business/reset/password/".concat(id),
    method: 'post'
  });
}